import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-24cd711c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "login-form"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("忘记密码");

var _hoisted_3 = {
  key: 0,
  class: "link-wrap"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "还没有账号？", -1);
});

var _hoisted_5 = /*#__PURE__*/_createTextVNode("立即注册");

import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { loginTip } from '@/config/constant';
import { checkEmail } from '@/utils/validate';
import { getUrlQuery } from '@/utils/login';
import { isMobile } from '@/utils/index'; // 声明 props，defineProps 接收与 props 选项相同的值

export default /*#__PURE__*/_defineComponent({
  props: {
    showLoginSwitch: {
      type: Boolean,
      default: false
    },
    loginText: {
      type: String,
      default: ''
    },
    loginWarn: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    bindCode: {
      type: String,
      default: ''
    }
  },
  emits: ["login"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var ruleFormRef = ref();
    var isMobileDevice = isMobile();
    var _window$AppConfig$hea = window.AppConfig.header.menuMap,
        menuMap = _window$AppConfig$hea === void 0 ? {} : _window$AppConfig$hea;
    var _window$AppConfig$reg = window.AppConfig.register.hideEntry,
        hideEntry = _window$AppConfig$reg === void 0 ? false : _window$AppConfig$reg;
    var _window$AppConfig$log = window.AppConfig.login.hideFindAccount,
        hideFindAccount = _window$AppConfig$log === void 0 ? false : _window$AppConfig$log;
    var route = useRoute();
    var router = useRouter();
    var nameError = ref('');
    var pwdError = ref('');
    var passwordType = ref('password');
    var formState = reactive({
      name: '',
      password: ''
    }); // 校验账户名称

    var validateName = function validateName(rule, value, callback) {
      nameError.value = checkEmail(value.trim());

      if (nameError.value) {
        callback(new Error(nameError.value));
      }

      callback();
    }; // 校验密码


    var validatePassword = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pwdError.value = value ? '' : loginTip.emptyPwd;
                pwdError.value ? callback(pwdError.value) : callback();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function validatePassword(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }(); // 校验规则


    var rules = reactive({
      name: [{
        validator: validateName,
        trigger: 'blur'
      }],
      password: [{
        validator: validatePassword,
        trigger: 'blur'
      }]
    }); // 登录

    var submitForm = function submitForm(formEl) {
      if (!formEl) return;
      formEl.validate(function (valid) {
        if (valid) {
          emit('login', formState);
        } else {
          return false;
        }
      });
    }; // 切换密码显示


    var togglePasswordType = function togglePasswordType() {
      passwordType.value = passwordType.value === 'password' ? 'text' : 'password';
    }; // 注册


    var goRegister = function goRegister() {
      var key = ['redirect_url', 'login_req_key', 'user_info_key', 'corpInvitationCode'];
      var paramStr = key.reduce(function (acc, item) {
        var query = route.query[item] ? "".concat(acc.indexOf('?') > -1 ? '&' : '?').concat(item, "=").concat(route.query[item]) : '';
        return acc + query;
      }, '');
      router.push("".concat(menuMap.register).concat(paramStr));
    }; // 忘记密码


    var goForgetPassword = function goForgetPassword() {
      var _route$query$redirect;

      var redirectUrl = ((_route$query$redirect = route.query.redirect_url) === null || _route$query$redirect === void 0 ? void 0 : _route$query$redirect.toString()) || '';
      var query = redirectUrl ? "?redirect_url=".concat(encodeURIComponent(redirectUrl)) : '';
      router.push("/account/find".concat(query));
    }; // 前往微信企微登录


    var goWxlogin = function goWxlogin() {
      router.push("/wxlogin".concat(getUrlQuery(route.query)));
    };

    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(['form-wrapper', _unref(isMobileDevice) && 'form-wrapper-mobile'])
      }, [_renderSlot(_ctx.$slots, "default"), _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: _unref(formState),
        "status-icon": "",
        rules: _unref(rules),
        "label-width": 0,
        class: "demo-ruleForm"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: "",
            prop: "name"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _unref(formState).name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).name = $event;
                }),
                class: "custom-input",
                autocomplete: "off",
                placeholder: "登录邮箱"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "",
            prop: "password"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                class: "custom-input",
                modelValue: _unref(formState).password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(formState).password = $event;
                }),
                type: passwordType.value,
                autocomplete: "off",
                placeholder: "密码",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(function ($event) {
                  return submitForm(ruleFormRef.value);
                }, ["enter"]))
              }, null, 8, ["modelValue", "type"]), _createElementVNode("i", {
                class: _normalizeClass(["iconfont password-type", passwordType.value === 'password' ? 'iconyincang1' : 'iconxianshi']),
                onClick: togglePasswordType
              }, null, 2), !_unref(hideFindAccount) ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                class: "link-button forget-password",
                onClick: goForgetPassword
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: "primary",
                class: "submit-button",
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return submitForm(ruleFormRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(__props.loginText || '登录'), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model", "rules"]), __props.showLoginSwitch ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "switch-login",
        onClick: goWxlogin
      })) : _createCommentVNode("", true)], 2), !_unref(hideEntry) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_button, {
        type: "text",
        class: "link-button",
        onClick: goRegister
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
});